module.exports = __webpack_public_path__ + "img/p4.f7700d5a.png";